export const adaptDelegacionesBOT = (delegacionData) => {
    return {
        id: delegacionData?.idDelegacion,
        displayName: delegacionData?.descripcion,
        name: delegacionData?.descripcion
    }
}

export const adaptDelegacionesBOTArray = (
    delegacion
) => {   
    return structuredClone(delegacion)
        ?.map(delegacion => adaptDelegacionesBOT(delegacion));
}